import { useEffect } from "react";
import { useAppDispatch } from "src/redux/hooks";
import { setLayoutProperties } from "src/redux/slices/configSlice";

const isInputOrTextarea = (el: EventTarget | null) =>
  el instanceof HTMLElement &&
  (el.tagName === "INPUT" || el.tagName === "TEXTAREA");

export default function useLayout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleFocusIn = (e: FocusEvent) => {
      if (isInputOrTextarea(e.target))
        dispatch(setLayoutProperties({ showBottomBar: false }));
    };

    const handleFocusOut = (e: FocusEvent) => {
      if (isInputOrTextarea(e.target) && !isInputOrTextarea(e.relatedTarget))
        dispatch(setLayoutProperties({ showBottomBar: true }));
    };

    // When keyboard dismisses (swipe, back, tap outside), focusout may not fire
    // but visualViewport expands. Show bottom bar so navigation isn't stuck.
    const handleViewportResize = () => {
      const vv = window.visualViewport;
      if (!vv) return;
      const heightRatio = vv.height / window.innerHeight;
      if (heightRatio > 0.75 && isInputOrTextarea(document.activeElement)) {
        dispatch(setLayoutProperties({ showBottomBar: true }));
      }
    };

    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    window.visualViewport?.addEventListener("resize", handleViewportResize);
    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
      window.visualViewport?.removeEventListener(
        "resize",
        handleViewportResize
      );
    };
  }, [dispatch]);
}
